import React from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';

const CommonPopupWrapperComponent = observer(props => {
  const {
    popupRef,
    titleText = '',
    content = '',
    actionBtn = '',
    customClass = '',
    customParentClass = '',
    customParentMaskClass = '',
    clickOutsidePopupCallback = () => {},
    showCloseBtn = false,
    closeClickCallback = () => {},
  } = props;

  return (
    <>
      <div
        className={`common-popup common-popup-wrapper ${customParentClass}`}
        ref={popupRef}
      >
        <div className={`popup-wrap ${customClass}`}>
          {showCloseBtn && (
            <div className="close-wrap" onClick={e => closeClickCallback(e)}>
              <CloseIcon />
            </div>
          )}
          {titleText && <div className="title-wrapper">{titleText}</div>}
          {content && <div className="content-wrapper">{content}</div>}
          {actionBtn && <div className="button-wrapper">{actionBtn}</div>}
        </div>
      </div>
      <div
        className={`common-popup-mask ${customParentMaskClass}`}
        onClick={e => clickOutsidePopupCallback(e)}
      />
    </>
  );
});

export { CommonPopupWrapperComponent };
export default CommonPopupWrapperComponent;
